'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _DefaultString = require('../../helpers/DefaultString');

var _PopupType = require('../../helpers/PopupType');

var _SegmentLogs = require('../../helpers/SegmentLogs');

var _PostLoginFlowStrategySelector = require('../../login/strategy/PostLoginFlowStrategySelector');

var _PostLoginFlowStrategySelector2 = _interopRequireDefault(_PostLoginFlowStrategySelector);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _QRCode = require('./QRCode.scss');

var _QRCode2 = _interopRequireDefault(_QRCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stingray = require('../../../res/images/common/icon_stingray.svg');
var reload = require('../../../res/images/common/reload.svg');

var NewQRCode = 'NewQrcode';
var QRSuccess = 'Success';

var QRCode = (_dec = (0, _reactRedux.connect)(function (state) {
  return { appInfo: state.appInfo, auth: state.auth, log: state.log };
}, { changePopupType: _popup.changePopupType, qrLogin: _auth.qrLogin, saveSid: _auth.saveSid, linkIdentityToAccount: _auth.linkIdentityToAccount, editQrLoginState: _auth.editQrLoginState, linkSecureToken: _auth.linkSecureToken, linkSSOToken: _auth.linkSSOToken, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(QRCode, _Component);

  function QRCode() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, QRCode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QRCode.__proto__ || (0, _getPrototypeOf2.default)(QRCode)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      qrCodeUrl: '',
      qrCodeRefreshing: true
    }, _this.componentDidMount = function () {
      _this._isMounted = true;
      _this.createWebSocket();

      // To break bfcache on firefox which cause this error GALVIP-2719
      window.addEventListener('unload', function () {});
    }, _this.componentWillUnmount = function () {
      _this._isMounted = false;
      _this.closeWebSocket();
    }, _this.onLoginSignUpSuccess = function (auth) {
      var loginStrategy = _PostLoginFlowStrategySelector2.default.getPostLoginFlowStrategy(auth, _this.props.appInfo, _this.props.pushState, _this.props.log);
      loginStrategy.handleUserInfoResponse(_this.props.linkIdentityToAccount, _this.props.linkSecureToken, _this.props.linkSSOToken);
    }, _this.closeWebSocket = function () {
      // Do not show the refresh button if it was a success.
      if (!_this.receivedSuccess && _this._isMounted) {
        _this.setState({ qrCodeRefreshing: false });
      }
      _this.connection.close();
    }, _this.createWebSocket = function () {
      _this.setState({ qrCodeRefreshing: true });
      _this.connection = new WebSocket((_config2.default.isSecured ? 'wss://' : 'ws://') + _this.props.appInfo.apiProxyUrl + 'ws/qrcode');
      _this.connection.onmessage = function (evt) {
        var response = JSON.parse(evt.data);
        if (response.type === NewQRCode) {
          // TODO final size???
          var qrCodeUrl = response.url.replace(_config2.default.universalLoginApiUrl + '/loginapi', '' + (_config2.default.isSecured ? 'https://' : 'http://') + _config2.default.apiProxyUrl);
          _this.setState({ qrCodeUrl: qrCodeUrl + '?size=240' });
        } else if (response.type === QRSuccess) {
          _this.receivedSuccess = true;
          _this.props.saveSid(_this.props.auth, response.sessionId);
          _this.props.qrLogin(response);
          (0, _SegmentLogs.identify)(response.userInfo.suid || response.userInfo.loginId, (0, _extends3.default)({}, response.userInfo));
        }
      };
      _this.connection.onclose = function () {
        _this.closeWebSocket();
      };
      _this.connection.onerror = function (evt) {
        console.log('Error with QRCode = ' + evt.data);
        _this.props.pushState();
      };
    }, _this.handleImgError = function () {
      if (_this.state.qrCodeUrl) {
        console.log('QR Code url error = ' + _this.state.qrCodeUrl);
        _this.props.pushState();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(QRCode, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.linkingIdentityToAccount && !nextProps.auth.linkingIdentityToAccount) {
        // Link Identity to Account
        if (nextProps.auth.error) {
          this.props.changePopupType(_PopupType.PopupId.UnknownError); // TODO GALVIP-3063 Error
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.linkingSecureToken && !nextProps.auth.linkingSecureToken || this.props.auth.linkingSSOToken && !nextProps.auth.linkingSSOToken) {
        if (nextProps.auth.error) {
          this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LinkExpired));
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (nextProps.auth.qrLogin && this.props.auth.userInfo !== nextProps.auth.userInfo) {
        this.props.editQrLoginState(false);
        this.onLoginSignUpSuccess(nextProps.auth);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          qrCodeUrl = _state.qrCodeUrl,
          qrCodeRefreshing = _state.qrCodeRefreshing;

      return _react2.default.createElement(
        'div',
        { className: _QRCode2.default.qrCodeContent },
        _react2.default.createElement('img', { className: _QRCode2.default.qrCode, src: qrCodeUrl, onError: this.handleImgError }),
        _react2.default.createElement('img', { className: _QRCode2.default.stingray, src: stingray }),
        !qrCodeRefreshing ? _react2.default.createElement(
          _reactBootstrap.Button,
          { className: _QRCode2.default.refreshButton, onClick: this.createWebSocket },
          _react2.default.createElement('div', { className: _QRCode2.default.refreshButtonBackground }),
          _react2.default.createElement('img', { className: _QRCode2.default.refreshImg, src: reload }),
          _react2.default.createElement(
            'div',
            { className: _QRCode2.default.refreshText },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.QRCodeReload)
          )
        ) : ''
      );
    }
  }]);
  return QRCode;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  editQrLoginState: _react.PropTypes.func,
  log: _react.PropTypes.object,
  linkIdentityToAccount: _react.PropTypes.func,
  linkSecureToken: _react.PropTypes.func,
  linkSSOToken: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired,
  qrLogin: _react.PropTypes.func.isRequired,
  saveSid: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = QRCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QRCode/QRCode.js
// module id = 1983
// module chunks = 0